import { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Button from '@/components/form/Button'
import Input from '@/components/form/Input'
import ReactSelect from '@/components/form/ReactSelect'
import { Translation } from '@/components/i18n/Translation'
import { LocalDate } from '@/components/LocalDate'
import {
  getDeviceOrder,
  getIsPostPending,
  getSelectedAlias,
  getSmsInputText,
  sendDeviceOrderSms,
  setAlias,
  setSmsInputText,
} from '@/ducks/deviceOrderReducer'
import { useProfile } from '@/hooks/user'
import { SEC } from '@/util/formatters/dates'

import './device-order-communications.scss'

const DeviceOrderCommunications = () => {
  const dispatch = useDispatch()
  const aliases = useProfile()?.aliases

  const smsInputText = useSelector(getSmsInputText)
  const selectedAlias = useSelector(getSelectedAlias)
  const isPostPending = useSelector(getIsPostPending)
  const { sms_log } = useSelector(getDeviceOrder)

  useEffect(() => {
    // @ts-ignore
    !selectedAlias && aliases.length > 0 && dispatch(setAlias(aliases[0].id))
  }, [selectedAlias, aliases, dispatch])
  // @ts-ignore
  const options = aliases.map(alias => ({
    value: alias.id,
    label: alias.alias,
  }))

  return (
    // @ts-ignore
    aliases.length > 0 && (
      <div className="device-order-communications">
        <h3>
          <Translation id="Communications" />
        </h3>

        <form>
          {/* @ts-ignore */}
          {aliases.length > 1 && (
            <>
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label>Sender</label>

              <ReactSelect
                options={options}
                value={selectedAlias}
                // @ts-ignore
                onChange={value => dispatch(setAlias(value))}
              />
            </>
          )}

          <Input
            label={<Translation id="New message" />}
            value={smsInputText}
            onChange={e => dispatch(setSmsInputText(e.target.value))}
            disabled={isPostPending}
          />

          <Button
            // @ts-ignore
            onClick={() => dispatch(sendDeviceOrderSms())}
            disabled={isPostPending || !smsInputText}
          >
            <Translation id="Send sms" />
          </Button>
        </form>

        {/* TODO: refactor and use SmsLogItem component */}
        <TransitionGroup className="sms-log">
          {/* @ts-ignore */}
          {sms_log.map(sms => (
            <Sms key={sms.sent} {...sms} />
          ))}
        </TransitionGroup>
      </div>
    )
  )
}

const Sms = ({ sender, message, sent }: any) => (
  <CSSTransition classNames="sms-wrapper" in={true} timeout={10 * SEC}>
    <div className="sms-wrapper">
      <div className="sender">{sender}</div>
      <div className="timestamp">
        <LocalDate date={sent} />
      </div>
      <div className="message">{message}</div>
    </div>
  </CSSTransition>
)

export default DeviceOrderCommunications
